import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { MyCommunicationStore } from '../stores/myCommunicationsStore';

export const useMyCommunicationsStore = () => useContext<{
  myCommunicationStore: MyCommunicationStore
}>(StoreContext);
